export default {
  dbl_create_dashboard_search: "Search",
  dbl_create_dashboard_tab: "Tab",
  dbl_create_dashboard_text: "Text",
  dbl_create_dashboard_text_placeholder: "Please enter content...",
  dbl_create_dashboard_text_background_color: "Background Color",
  dbl_create_dashboard_filter: "Filter",
  dbl_create_dashboard_filter_type: "Filter Type",
  dbl_create_dashboard_filter_type_placeholder: "Please select filter type",
  dbl_create_dashboard_default_type: "Default Type",
  dbl_create_dashboard_default_type_placeholder: "Please select default type",
  dbl_create_dashboard_default_value: "Default Value",
  dbl_create_dashboard_default_value_placeholder: "Please select",
  dbl_create_dashboard_filter_name: "Filter Name",
  dbl_create_dashboard_filter_name_placeholder: "Enter a filter name",
  dbl_create_dashboard_filter_name_length_error: "The content must contain less than 10 chars",
  dbl_create_dashboard_dataset: "Dataset",
  dbl_create_dashboard_dataset_placeholder: "Please select dataset",
  dbl_create_dashboard_column: "Field",
  dbl_create_dashboard_column_placeholder: "Please select field",
  dbl_create_dashboard_input: "Input on the right",
  dbl_create_dashboard_date: "Date",
  dbl_create_dashboard_string: "String",
  dbl_create_dashboard_value: "Value",
  dbl_create_dashboard_country: "Country",
  dbl_create_dashboard_option_value: "Option Value",
  dbl_create_dashboard_scope: "Scope",
  dbl_create_dashboard_scope_show: "Show Scope",
  dbl_create_dashboard_scope_setting: "Scope Setting",
  dbl_create_dashboard_user_filter_info: 'User filter is only effective on charts with associated user attribute. Currently supported chart types include: tables, line charts, bar charts, and big number cards.',
  dbl_create_dashboard_user_filter_scope_setting_info: 'Currently supported chart types include: tables, line charts, bar charts, and big number cards.',
  // dbl_create_dashboard_scope_info: "Filter will be automatically associated with the chart where the query field exists and the rest of the chart can specify the associated field.",
  dbl_create_dashboard_scope_same: "Apply to same dataset",
  dbl_create_dashboard_scope_same_info: "All charts with this dataset will be affected by this filter",
  dbl_create_dashboard_scope_specific: "Apply to specific charts",
  dbl_create_dashboard_scope_specific_info: "Only selected charts will be affected by this filter",
  dbl_create_dashboard_scope_join_placeholder: "Linking Field",
  dbl_create_dashboard_scope_join_error: "Linking field type mismatch",
  dbl_create_dashboard_scope_join_empty: "Can not be blank",
  dbl_create_dashboard_filter_option_desc: "Original Dimension Value",
  dbl_create_dashboard_filter_dataset_desc: "Same Data Set",

  dbl_create_dashboard_svae_dashboard: "Save Dashboard",
  dbl_create_dashboard_svae_template: "Save Template",
  dbl_create_dashboard_dashboard_name: "Dashboard Name",
  dbl_create_dashboard_dashboard_placeholder: "Please enter a dashboard name",
  dbl_create_dashboard_dashboard_same: "A report with the same name already exists. Please re-enter it",
  dbl_create_dashboard_name_length_error: "The content must contain less than 50 chars",
  dbl_create_dashboard_blank_title: "Drag and drop components and charts to the dashboard",
  dbl_create_dashboard_blank_des: "You can create a new chart or use existing ones from the panel on the right",
  dbl_create_dashboard_un_named: "Unnamed Dashboard",
  dbl_create_dashboard_layout_elements: "Layout Elements",
  dbl_create_dashboard_chart: "Charts",
  dbl_create_dashboard_sort_by_time_desc: "Sort by Time",
  dbl_create_dashboard_sort_by_time_asc: "Sort by Time",
  dbl_create_dashboard_leave_title: "Leave the current dashboard task?",
  dbl_create_dashboard_leave_des: "The current page has not been saved. Leaving will result in the loss of all content.",
  dbl_create_dashboard_check_date_fail: "Unable to convert to date type",
  dbl_create_dashboard_check_date: "Verification date type",
	
  dbl_create_dashboard_add_filter: "Add filter",
  dbl_create_dashboard_delete_filter_title: "Confirm deleting the filter?",
  dbl_create_dashboard_delete_filter_content: "The delete operation cannot be undone, please proceed with caution.",
	
  dbl_create_dashboard_applied: "Applied filters ({count})",
  
  dbl_create_dashboard_dataset_search_placeholder: "You can find more datasets through search.",
  // dbl_create_dashboard_dataset_search_bottom_tip: "You can find more datasets through search.",
  dbl_create_dashboard_dataset_detail_name: 'Name',
  dbl_create_dashboard_dataset_detail_database_type: 'Database type',
  dbl_create_dashboard_dataset_detail_database_name: 'Database name',
  dbl_create_dashboard_dataset_detail_schema: 'Schema',
  dbl_create_dashboard_dataset_detail_description: 'Description',
  
  dbl_create_dashboard_same_dataset: 'Same Dataset',
  dbl_create_dashboard_related_dataset: 'Related Dataset',
  dbl_create_dashboard_other_dataset: 'Other Datasets',
  
  dbl_create_dashboard_data_source: 'Data Source',
  
  dbl_create_dashboard_icon_explore: 'Explore',
  dbl_create_dashboard_explore_tip: 'New feature: Exploration. Click here to explore!',
  
  dbl_create_dashboard_tab_rename: 'Rename',
  dbl_create_dashboard_tab_delete: 'Delete',
  dbl_create_dashboard_tab_add: 'Add Tab',
  dbl_create_dashboard_tab_duplicate_name: 'Duplicate Naming',
  dbl_create_dashboard_tab_delete_title: 'Delete dashboard tab?',
  dbl_create_dashboard_tab_delete_desc: 'Delete {name}? Deleting a tab will remove all content within it.',
  
  dbl_create_dashboard_default_date: 'Default date: Last date',
  dbl_create_dashboard_default_date_info: 'Entering the Dashboard, the card chart displays the last date data by default, after adjusting the filter date, the card will display the aggregated data for the selected date.',
  
  dbl_create_dashboard_depend: 'Dependent on',
  dbl_create_dashboard_relevant_config_title: 'Relevant Filter Configuration',
  dbl_create_dashboard_relevant_config_info: 'Support configuring other string filters from the same dataset as relevant to the current filter, displaying only relevant values.',
  dbl_create_dashboard_relevant_config_add: 'Add sub filter',
  dbl_create_dashboard_relevant_has_add_info: '{filterName} has been added to the sub-filters and cannot be added again',
  dbl_create_dashboard_relevant_has_parent: '{filterName} has been configured as a parent filter',
  
  dbl_create_dashboard_show_contact: 'Show Contact',
  dbl_create_dashboard_basic_components: 'Basic Components',
  dbl_create_dashboard_show_contact_info: 'The dashboard will display the [Last Updated By] information',
  dbl_create_dashboard_contact_error: 'Failed to retrieve contacts',
  
  dbl_dashboard_contact_prefix: 'If you have any questions, please contact creator ',
  
  dbl_create_dashboard_show_only_my_charts: 'Show only my charts',
  
  dbl_create_dashboard_disabled_default_date: 'This function cannot be used while comparison time is active',
};